export default "__VITE_ASSET__BBlPKo9X__"